import { useState, useEffect, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { InputMask } from '@react-input/mask';
import Select from 'react-select';
import FileDropzone from './FileDropzone';
import { NumericFormat } from 'react-number-format';
import moment from 'moment';
import 'moment/locale/pt';

import { useToken } from '../TokenContext';

export const FormEditPremio = () => {
    const [loading, setLoading] = useState(true);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [premioData, setPremioData] = useState({
        numero_rastreamento: '',
        status: '',
        status_entrega: '',
    });

    const [userErrorData, setUserErrorData] = useState({
        numero_rastreamento: [],
        status: [],
    });

    const [formLoading, setFormLoading] = useState(false);
    const [error, setError] = useState('');

    const executedRef = useRef(false);

    const selectOptions = [
        { value: 'carrinho', label: 'Carrinho' },
        { value: 'finalizado', label: 'Finalizado' },
        { value: 'aprovado', label: 'Aprovado' },
        { value: 'reprovado', label: 'Reprovado' },
    ];

    const selectStatusOptions = [
        { value: 'Aguardando', label: 'Aguardando' },
        { value: 'Em separação', label: 'Em separação' },
        { value: 'Em transporte', label: 'Em transporte' },
        { value: 'Entregue', label: 'Entregue' },
    ];

    const { tokenData } = useToken();
    const navigate = useNavigate();
    const { id } = useParams();
    const accessToken = localStorage.getItem('access_token');
    const baseUrl = process.env.REACT_APP_API_URL;

    const fetchPremio = async () => {
        setLoading(true);
        try {
            const response = await fetch(`${baseUrl}/manager/carrinhos/editar/${id}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${accessToken}`,
                },
            });

            if (!response.ok) {
                setError('Erro ao buscar os dados do prêmio.');
            }

            const data = await response.json();
            console.log(data)
            setPremioData(data.carrinho);

        } catch (error) {
            setError(error.message);
        } finally {
            setLoading(false);
        }
    };
    
    useEffect(() => {
        fetchPremio();
    }, []);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setPremioData(prevData => ({
            ...prevData,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSelectChange = (name, selectedOption) => {
        setPremioData(prevData => ({
            ...prevData,
            [name]: selectedOption.value
        }));
    };
   
    const handleSubmit = async (e) => {
        
        e.preventDefault();
        setFormLoading(true);

        try {
            const response = await fetch(`${baseUrl}/manager/carrinhos/editar/${id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`
                },
                body: JSON.stringify(premioData)
            });

            const result = await response.json();

            if (!response.ok) {
                setFormLoading(false);
                setUserErrorData(result);
                setError('Erro ao editar a venda');
                navigate(`/manager/premios/editar/${id}`, {
                    state: {
                        message: { type: 'error', text: result.message ?? 'Por favor, verifique o(s) campo(s) sinalizados em vermelho.' },
                    },
                });
                return;
            }

            setFormLoading(false);
            navigate(`/manager/premios/editar/${id}`, {
                state: {
                    message: { type: 'success', text: result.message },
                },
            });
            
        } catch (error) {
            setFormLoading(false);
            setError(error.message);
        }
    };


    if (loading) return (
        <div className="mx-auto py-10">
            <div className="h-16 w-16 animate-spin rounded-full border-4 border-solid border-primary border-t-transparent"></div>
        </div>
    );

    return (
        <>
            <form onSubmit={handleSubmit} className="max-w-5xl pb-10">
                 <div className="mb-6 2xl:mb-10">
                    <h4 className="flex gap-6 items-center font-secondary text-md font-bold whitespace-nowrap mb-3 2xl:mb-5">Dados da venda <span className="w-full border-t" /></h4>
                    <div className="w-full mb-6 text-gray-900 divide-y divide-gray-200 dark:text-white dark:divide-gray-700">
                        <div className="flex flex-col">
                            <dt className="mb-1 md:text-md font-semibold">Representante</dt>
                            <dd className="text-gray-500">{premioData.nome}</dd>
                        </div>
                        <div className="flex flex-col py-3 pb-0">
                            <dt className="mb-1 md:text-md font-semibold">CPF</dt>
                            <dd className="text-gray-500">{premioData.cpf}</dd>
                        </div>
                        <div className="flex flex-col pt-3">
                            <dt className="mb-1 md:text-md font-semibold">Razão Social</dt>
                            <dd className="text-gray-500">{premioData.razao}</dd>
                        </div>
                        <div className="flex flex-col pt-3">
                            <dt className="mb-1 md:text-md font-semibold">CNPJ</dt>
                            <dd className="text-gray-500">{premioData.cnpj}</dd>
                        </div>
                        <div className="flex flex-col pt-3">
                            <dt className="mb-1 md:text-md font-semibold">Data de contrato</dt>
                            <dd className="text-gray-500"> 
                                { moment(premioData.status).locale('pt').format('DD/MM/YYYY')}
                            </dd>
                        </div>
                        <div className="flex flex-col pt-3">
                            <dt className="mb-1 md:text-md font-semibold">Pontos</dt>
                            <dd className="text-gray-500">{premioData.pontos ?? '0'}</dd>
                        </div>
                    </div>

                    <div className="mb-3 flex gap-5 lg:gap-15 flex-col lg:flex-row">
                        <div className="w-full">
                            <label className="block text-sm font-medium mb-3">Código de rastreamento</label>
                            <input
                                type="text"
                                name="numero_rastreamento"
                                value={premioData.numero_rastreamento}
                                onClick={() => setUserErrorData(prevData => ({...prevData, numero_rastreamento: []}))}
                                onChange={handleChange}
                                className="w-full px-3 py-1.5 2xl:py-2 border border-gray-300 rounded-md outline-none focus:border-secondary focus-visible:shadow-none"
                                
                            />
                            {userErrorData.numero_rastreamento && userErrorData.numero_rastreamento[0] && (<span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">{userErrorData.numero_rastreamento[0]} <span onClick={() => setUserErrorData(prevData => ({...prevData, numero_rastreamento: []}))} className="rotate-45 -my-2 p-2 cursor-pointer">+</span></span>)}
                        </div>
                        <div className="w-full">
                            <label className="block text-sm font-medium mb-3">Status</label>
                            <Select
                                name="status"
                                options={selectOptions}
                                value={selectOptions.find(option => option.value === premioData.status) || null}
                                onClick={() => setUserErrorData(prevData => ({...prevData, status: []}))}
                                onChange={selectedOption => handleSelectChange('status', selectedOption)}
                                placeholder="Selecione uma opção..."
                                className="user-select"
                            />
                            {userErrorData.status && userErrorData.status[0] && (<span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">{userErrorData.status[0]} <span onClick={() => setUserErrorData(prevData => ({...prevData, status: []}))} className="rotate-45 -my-2 p-2 cursor-pointer">+</span></span>)}
                        </div>
                        <div className="w-full">
                            <label className="block text-sm font-medium mb-3">Status da entrega</label>
                            <Select
                                name="status_entrega"
                                options={selectStatusOptions}
                                value={selectStatusOptions.find(option => option.value === premioData.status_entrega) || null}
                                onClick={() => setUserErrorData(prevData => ({...prevData, status_entrega: []}))}
                                onChange={selectedOption => handleSelectChange('status_entrega', selectedOption)}
                                placeholder="Selecione uma opção..."
                                className="user-select"
                            />
                            {userErrorData.status_entrega && userErrorData.status_entrega[0] && (<span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">{userErrorData.status_entrega[0]} <span onClick={() => setUserErrorData(prevData => ({...prevData, status_entrega: []}))} className="rotate-45 -my-2 p-2 cursor-pointer">+</span></span>)}
                        </div>
                    </div>
                </div>

                <button
                    type="submit"
                    className="w-full bg-primary text-white py-2 px-4 rounded-md hover:bg-opacity-80 disabled:bg-opacity-80 disabled:cursor-not-allowed"
                    
                >
                    {!formLoading ? (
                        'Salvar'
                    ) : (
                        <div role="status" className="flex justify-center items-center">
                            <svg aria-hidden="true" className="w-6 h-6 text-white text-opacity-60 animate-spin fill-white" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                                <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
                            </svg>
                            <span className="sr-only">Loading...</span>
                        </div>
                    )}
                </button>
            </form>
        </>
    );
}
